// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export var EDealType = /*#__PURE__*/function (EDealType) {
  EDealType["Rent"] = "rent";
  EDealType["Sale"] = "sale";
  return EDealType;
}({});
export var EOfferType = /*#__PURE__*/function (EOfferType) {
  EOfferType["Commercial"] = "commercial";
  EOfferType["Flat"] = "flat";
  EOfferType["Newobject"] = "newobject";
  EOfferType["Suburban"] = "suburban";
  return EOfferType;
}({});